module.exports = __webpack_public_path__ + "assets/d41a98dd6bc0e03ad409b19af9aa1b17.mp3";